import { Swiper, SwiperSlide } from "swiper/react";

import { Pagination, Navigation } from "swiper/modules";

// Import Swiper styles
import "./Banner.css";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { useNavigate } from "react-router-dom";
import { useEffect, useState ,useRef} from "react";
import { useAppDispatch } from "../../../../../app/redux/hooks";
import { getAdInfoAsync } from "../../../../../app/slices/bannerSlice/BannerSlice";
import { setSelectProduct } from "../../../../../app/slices/productDiscriptionSlice/ProductDescriptionSlice";
import CustomDialog from "../../../../components/custom/dialog";
import { CouponComponent } from "../../../private/chekout/components/myCart/CouponCodes";
import { showSnackbar } from "../../../../../app/slices/common/customSnackBar/customSnackbarSlice";
import { getDecryptedToken } from "../../../../../app/auth/authHandler";

export const Banner = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [filteredAds, setFilteredAds] = useState([]);
  const [modalType, setModalType] = useState("");
  const hasFetched = useRef(false);
  useEffect(() => {
    if ( hasFetched.current) return; 
    dispatch(getAdInfoAsync()).then((response: any) => {
      if (response.payload?.status === 200) {
        const res = response?.payload?.data;
        const filtered = res?.data?.ads?.filter((ad: any) =>
          ad.AdPlacement.includes("Top")
        );
        setFilteredAds(filtered);
      }
    });
  }, []);

  const handleBannerClick = (item: any) => {
    if (item?.AdType === "Product" && item?.Product?.id) {
      dispatch(setSelectProduct(item?.Product?.id));
      localStorage.setItem("product_id", item?.Product?.id);
      navigate(`/products/${item?.Product?.id}`);
    } else if (item?.AdType === "Discount" && item?.Discount?.id) {
      // dispatch(setSelectDiscount(item?.Product?.id));
      localStorage.setItem("offer_id", item?.Discount?.id);
      navigate(`offerList/orders/discounts/${item?.Discount?.id}/`);
    } else if (item?.AdType === "Coupon" && item?.Coupon?.id) {
      const accessToken = getDecryptedToken();
      if (accessToken) {
        setModalType("couponCode");
      } else {
        dispatch(
          showSnackbar({
            message: "Please log in to view the available coupons",
            severity: "error",
            autoHide: 2000,
          })
        );
      }
    }
  };
  const onCloseModal = () => {
    setModalType("");
  };
  return (
    <>
      <section className="tf-slideshow slideshow-effect slider-effect-fade position-relative">
        <div className="swiper tf-sw-effect">
          <div className="swiper-wrapper">
            <Swiper
              spaceBetween={30}
              // freeMode={true}
              pagination={{ clickable: true }}
              navigation={true}
              breakpoints={{
                1024: { slidesPerView: 1, spaceBetween: 10 }, // Desktop: 5 slides
                768: { slidesPerView: 1, spaceBetween: 15 }, // Tablet: 2 slides
                480: { slidesPerView: 1, spaceBetween: 15 }, // Mobile: 1 slide
              }}
              modules={[Pagination, Navigation]}
              // className="mySwiper"
            >
              {/* First Slide */}
              {filteredAds.map((slide: any, index) => (
                <SwiperSlide className="swiper-slide" key={index}>
                  <div className="slider-effect wrap-slider">
                    <div className="content-left">
                      <div className="container">
                        <div className="row">
                          <div className="col-md-6 col-12">
                            <div
                              className="box-content"
                              style={{ marginRight: "1rem" }}
                            >
                              <h1 className="heading fade-item fade-item-1">
                                {slide.AdTitle}
                              </h1>
                              <p className="desc fade-item fade-item-2">
                                {slide.AdDescription}
                              </p>
                              {/* commented on 12/02  */}

                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => handleBannerClick(slide)}
                                className="fade-item fade-item-3 tf-btn btn-light-icon animate-hover-btn btn-xl radius-3"
                              >
                                Shop collection
                                <i className="icon icon-arrow-right"></i>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="img-slider" style={{ height: "100%" }}>
                      <img
                        style={{ width: "100%", objectFit: "fill" }}
                        className="ls-is-cached lazyloaded"
                        data-src={`${process.env.REACT_APP_API_URL}${slide?.StandardImage}`}
                        src={`${process.env.REACT_APP_API_URL}${slide?.StandardImage}`}
                        alt="fashion-slideshow"
                      />
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
            <div className="wrap-pagination">
              <div className="container">
                <div className="sw-dots line-pagination sw-pagination-slider">
                  {/* Pagination */}
                </div>
              </div>
            </div>
            {/* Pagination */}
          </div>
        </div>
      </section>
      <CustomDialog
        component={
          <CouponComponent modalType={modalType} onCloseModal={onCloseModal} />
        }
        title=""
        openDialog={modalType === "couponCode"}
        handleCloseDialog={onCloseModal}
        modalPlace="right"
      />
    </>
  );
};
